// extracted by mini-css-extract-plugin
export default {"contactInfoLabel":"Contacts_contactInfoLabel__J8+Lh","contactInfoValue":"Contacts_contactInfoValue__j3NEM"};